import { supabase } from "@/api/supabase";
import { decodeJwtPayload, parseClaims, type AppClaims } from "@/domain/auth/claims";

/**
 * The tenant/role claims in the current access token.
 *
 * A token issued before the access-token hook was enabled has none, so the
 * session is refreshed once to get a fresh token that does. If that token
 * still has none the user has no access (or the hook is off).
 */
export async function getAppClaims(): Promise<AppClaims | null> {
  const current = await supabase.auth.getSession();
  const token = current.data.session?.access_token;
  const claims = token ? parseClaims(decodeJwtPayload(token)) : null;
  if (claims !== null || !current.data.session) {
    return claims;
  }

  const refreshed = await supabase.auth.refreshSession();
  const fresh = refreshed.data.session?.access_token;
  return fresh ? parseClaims(decodeJwtPayload(fresh)) : null;
}
